import React, { useEffect, useState } from 'react';
import { Pause, Play } from 'lucide-react';
import { DEMOS, DEMO_SCENE_MS } from './scenes';
import './plus360-demo.css';

const POSTER_MS = 1400;
const reduced = () => typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

/** Démo animée ~15 s : affiche (illustration) → 4 scènes en boucle, légende par scène, pause/lecture. */
export const Plus360Demo = ({ mod, testId = 'plus360-demo', children }) => {
  const scenes = DEMOS[mod.key] || [];
  const [scene, setScene] = useState(-1);
  const [paused, setPaused] = useState(false);
  const still = reduced() || !scenes.length;

  useEffect(() => {
    if (still || paused) return undefined;
    const t = setTimeout(() => setScene((s) => (s + 1) % scenes.length), scene < 0 ? POSTER_MS : DEMO_SCENE_MS);
    return () => clearTimeout(t);
  }, [scene, paused, still, scenes.length]);

  const cur = scene >= 0 ? scenes[scene] : null;
  return <figure className={`plus-demo ${cur ? 'is-playing' : 'is-poster'}`} data-testid={testId} data-scene={scene}>
    <img src={mod.image} alt="" className="plus-demo-poster" loading="lazy" data-testid={`${testId}-poster`} />
    {cur && <div key={scene} className="plus-demo-stage" data-testid={`${testId}-stage`}>{cur.render()}</div>}
    {children}
    {!still && <div className="plus-demo-bar" data-testid={`${testId}-bar`}>
      <span className="plus-demo-caption" data-testid={`${testId}-caption`}>{cur ? cur.caption : `${mod.label} en action · 15 s`}</span>
      <span className="plus-demo-dots" aria-hidden>{scenes.map((_, k) => <i key={k} className={k === scene ? 'is-on' : k < scene ? 'is-done' : ''} />)}</span>
      <button type="button" className="plus-demo-btn" onClick={() => setPaused((p) => !p)} aria-label={paused ? 'Lecture' : 'Pause'} data-testid={`${testId}-toggle`}>{paused ? <Play size={13} /> : <Pause size={13} />}</button>
    </div>}
  </figure>;
};
